import { Box, Heading } from '@hover/blueprint';
import React from 'react';

import { PrimaryCTA } from 'src/modules/renderings/components/RenderingsHub/RenderingsList/PrimaryCTA';
import { useIsDesktopSize } from 'src/modules/renderings/hooks/useIsDesktopSize';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { OrgBranding } from '../OrgBranding';

interface RenderingsListProps {
  headerShadow?: string;
  children: React.ReactNode;
  renderingName?: string | null;
}

export const CTA_BUTTON_CONTAINER_TEST_ID = 'cta_button_test_id';

const RenderingsList = ({
  renderingName,
  headerShadow,
  children,
}: RenderingsListProps) => {
  const isDesktopSize = useIsDesktopSize();
  const t = useTranslate(TranslationNamespace.SHARED);

  return (
    <Box flexDirection="column">
      <Box
        alignItems="center"
        backgroundColor="neutral.0"
        borderBottomColor="neutral.300"
        borderBottomStyle={{ base: 'unset', tablet: 'solid', desktop: 'unset' }}
        borderBottomWidth={{ base: 'unset', tablet: '1px', desktop: 'unset' }}
        boxShadow={headerShadow}
        justifyContent="space-between"
        marginX={{ base: 'unset', tablet: 400, desktop: 'unset' }}
        paddingX={{ base: 400, tablet: 0, desktop: 400 }}
        paddingY={500}
        position="sticky"
        top={0}
        zIndex={10}
      >
        <Heading
          display={{ base: 'none', tablet: 'flex', desktop: 'none' }}
          marginBottom={0}
          size={500}
        >
          {renderingName || t('renderings.yourProject')}
        </Heading>
        <PrimaryCTA />
      </Box>
      <Box
        flexDirection="column"
        marginY={{ base: 200, tablet: 400 }}
        paddingX={400}
        width="100%"
      >
        {children}
        {!isDesktopSize && (
          <Box
            justifyContent={{ base: 'center', tablet: 'flex-start' }}
            paddingY={300}
          >
            <OrgBranding />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export { RenderingsList };
